<template>
  <header>
    <div class="o-container o-container--xlarge">
      <router-link :to="{ name: 'Home' }"
        ><img
          class="o-logo"
          src="@/assets/images/Logo_BEX_Neutral_Metall_RGB.svg"
          :alt="$t('components.header.logo.alt')"
      /></router-link>

      <nav class="o-main-navigation">
        <ul>
          <li
            class="u-display-none@large"
            v-if="$route.fullPath !== '/' && $route.path !== '/oidc-callback'"
          >
            <fair-navigation />
          </li>
          <router-link
            v-if="checkAccess(link)"
            v-for="link in navigation"
            :key="link.key || link.name"
            :class="[
              `main-navigation-link--${link.name.toLowerCase()}`,
              { 'has-dropdown': link.children }
            ]"
            :to="getLinkTo(link)"
            tag="li"
          >
            <div class="mainnavi-link" v-if="link.textOnly" @click.prevent>
              <font-awesome-icon
                v-if="link.iconBefore"
                class="icon-before"
                :icon="link.iconBefore"
              />{{ getLinkText(link)
              }}<font-awesome-icon
                v-if="link.iconAfter"
                class="icon-after"
                :icon="link.iconAfter"
              />
            </div>
            <button
              class="mainnavi-link"
              v-else-if="link.action"
              @click.prevent="link.action"
            >
              <font-awesome-icon
                v-if="link.iconBefore"
                class="icon-before"
                :icon="link.iconBefore"
              />{{ getLinkText(link)
              }}<font-awesome-icon
                v-if="link.iconAfter"
                class="icon-after"
                :icon="link.iconAfter"
              />
            </button>
            <a v-else class="mainnavi-link">
              <font-awesome-icon
                v-if="link.iconBefore"
                class="icon-before"
                :icon="link.iconBefore"
              />{{ getLinkText(link)
              }}<font-awesome-icon
                v-if="link.iconAfter"
                class="icon-after"
                :icon="link.iconAfter"
              />
              <span v-if="link.hasNotifications" class="icon-notifications" />
            </a>

            <ul v-if="link.children">
              <router-link
                v-for="child in link.children"
                :key="child.name"
                :class="[`main-navigation-link--${child.name.toLowerCase()}`]"
                :to="getLinkTo(child)"
                tag="li"
              >
                <div class="mainnavi-link" v-if="child.textOnly" @click.prevent>
                  <font-awesome-icon
                    v-if="child.iconBefore"
                    class="icon-before"
                    :icon="child.iconBefore"
                  />{{ getLinkText(child)
                  }}<font-awesome-icon
                    v-if="child.iconAfter"
                    class="icon-after"
                    :icon="child.iconAfter"
                  />
                </div>
                <button
                  class="mainnavi-link"
                  v-if="child.action"
                  @click.prevent="child.action"
                >
                  <font-awesome-icon
                    v-if="child.iconBefore"
                    class="icon-before"
                    :icon="child.iconBefore"
                  />{{ getLinkText(child)
                  }}<font-awesome-icon
                    v-if="child.iconAfter"
                    class="icon-after"
                    :icon="child.iconAfter"
                  />
                </button>
                <a class="mainnavi-link" v-else
                  ><font-awesome-icon
                    v-if="child.iconBefore"
                    class="icon-before"
                    :icon="child.iconBefore"/>{{ getLinkText(child)
                  }}<font-awesome-icon
                    v-if="child.iconAfter"
                    class="icon-after"
                    :icon="child.iconAfter"
                /></a>
              </router-link>
            </ul>
          </router-link>
          <li>
            <LanguageSwitcher />
          </li>
        </ul>
      </nav>

      <div class="o-nav-toggler" @click="toggleMenu()">
        <div class="o-nav-toggler__item"></div>
        <div class="o-nav-toggler__item"></div>
        <div class="o-nav-toggler__item"></div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getRouteByName, getFlatRoutes } from '@/assets/js/helper'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import FairNavigation from '@/components/FairNavigation.vue'

export default {
  name: 'BosHeader',
  data() {
    return {
      navigation: [
        {
          name: getRouteByName('AdminHome').name,
          iconBefore: 'lock'
        },
        {
          name: getRouteByName('Home').name
        },
        /*
        {
          name: getRouteByName('MessageCenter').name,
          hasNotifications: () => this.hasUnreadNotifications
        },

           */
        {
          name: 'Username',
          computedText: () => (this.oidcUser || {}).name,
          textOnly: true,
          children: [
            {
              name: getRouteByName('Profile').name
            },
            {
              name: 'Logout',
              action: this.logout
              //              iconAfter: 'power-off'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['oidcUser']),
    notifications() {
      return this.$store.getters['notifications/get']
    },
    hasUnreadNotifications() {
      return (
        this.notifications.filter(notification => notification.unread).length >
        0
      )
    }
  },
  methods: {
    ...mapActions(['signOutOidc']),
    toggleMenu() {
      this.$root.$emit('toggle::menustate')
    },
    getLinkTo(link) {
      return !link.action && !link.textOnly ? { name: link.name } : '#'
    },
    getLinkText(link) {
      return link.computedText
        ? link.computedText()
        : this.$t(`components.header.link.${link.name}`)
    },
    logout() {
      // TODO: Insert correct Logout logic
      this.signOutOidc()
    },
    checkAccess(link) {
      const route = getRouteByName(link.name)
      if (
        route !== undefined &&
        route.meta !== undefined &&
        route.meta.requiresAdmin === true
      ) {
        if (this.$store.getters['user/roles'].indexOf('ONESHOP_MANAGER') > -1) {
          return true
        }
        return false
      }
      return true
    }
  },
  components: {
    LanguageSwitcher,
    FairNavigation
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$header-padding: 1rem 0 0.75rem !default;
$header-bg: #f6f6f6 !default;

$header-mobile-height: 86px !default;

$mainnavi-seperator: 1px solid darken($header-bg, 15%) !default;

$mainnavi-linkitem-padding: 0 1em !default;
$mainnavi-link-padding: 0.6em 0 !default;
$mainnavi-link-color: inherit !default;
$mainnavi-link-textdecoration: none !default;
$mainnavi-link-hover-color: $brand-primary !default;
$mainnavi-link-active-color: $brand-primary !default;

$mainnavi-link-icon-notification-size: 10px !default;
$mainnavi-link-icon-notification-bg: $brand-red !default;
$mainnavi-link-icon-notification-gap: 0.25em !default;

$mainnavi-dropdown-bg: white !default;
$mainnavi-dropdown-link-padding: 0.6em 0.8em !default;
$mainnavi-dropdown-link-font-size: $mainnavi-link-font-size * 0.9 !default;
$mainnavi-dropdown-link-color: black !default;
$mainnavi-dropdown-link-textdecoration: $mainnavi-link-textdecoration !default;
$mainnavi-dropdown-link-hover-bg: $brand-primary !default;
$mainnavi-dropdown-link-hover-color: black !default;
$mainnavi-dropdown-link-active-bg: $mainnavi-dropdown-link-hover-bg !default;
$mainnavi-dropdown-link-active-color: $mainnavi-dropdown-link-hover-color !default;
$mainnavi-dropdown-icon-gap: 0.5em !default;

$mainnavi-toggler-item-gap: 7px !default;
$mainnavi-toggler-item-width: 40px !default;
$mainnavi-toggler-item-height: 6px !default;
$mainnavi-toggler-item-bg: $brand-primary !default;
$mainnavi-toggler-item-transition: all 300ms ease-in-out !default;

$mainnavi-mobile-bg: $header-bg !default;
$mainnavi-mobile-toggle-transition: all 500ms
  cubic-bezier(0.62, 0.16, 0.03, 0.96) !default;

$mainnavi-mobile-linkitem-padding: $mainnavi-linkitem-padding !default;
$mainnavi-mobile-link-padding: 0.5em 0 !default;
$mainnavi-mobile-link-font-size: $mainnavi-link-font-size !default;
$mainnavi-mobile-link-color: $mainnavi-link-color !default;
$mainnavi-mobile-link-hover-color: $mainnavi-link-hover-color !default;
$mainnavi-mobile-link-active-color: $mainnavi-link-active-color !default;

$mainnavi-mobile-dropdown-bg: transparent !default;
$mainnavi-mobile-dropdown-link-padding: $mainnavi-mobile-link-padding !default;
$mainnavi-mobile-dropdown-link-font-size: $mainnavi-mobile-link-font-size !default;
$mainnavi-mobile-dropdown-link-color: $mainnavi-mobile-link-color !default;
$mainnavi-mobile-dropdown-link-hover-bg: $mainnavi-mobile-dropdown-bg !default;
$mainnavi-mobile-dropdown-link-hover-color: $mainnavi-mobile-link-hover-color !default;
$mainnavi-mobile-dropdown-link-active-bg: $mainnavi-mobile-dropdown-bg !default;
$mainnavi-mobile-dropdown-link-active-color: $mainnavi-mobile-link-active-color !default;

header {
  position: fixed;
  width: 100%;
  top: 0;
  padding: $header-padding;
  background-color: $header-bg;

  .o-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .o-logo {
    display: block;
    margin-top: 6px;
    max-width: 166px;
    width:100%;
  }

  .o-main-navigation {
    margin-top: -0.2em;
    text-align: left;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        .mainnavi-link {
          display: block;
          position: relative;
          margin: 0;
          padding: 0;
          width: 100%;
          background: none;
          border: 0 none;
          font-family: inherit;
          font-size: inherit;
          font-weight: inherit;
          text-align: inherit;

          .icon-before {
            margin-right: $mainnavi-dropdown-icon-gap;
          }

          .icon-after {
            margin-left: $mainnavi-dropdown-icon-gap;
          }

          .icon-notifications {
            display: inline-block;
            margin-left: $mainnavi-link-icon-notification-gap;
            width: $mainnavi-link-icon-notification-size;
            height: $mainnavi-link-icon-notification-size;
            background-color: $mainnavi-link-icon-notification-bg;
            vertical-align: top;
            border-radius: 50%;
          }
        }

        div.mainnavi-link {
          cursor: default;
        }
      }
    }

    > ul {
      display: flex;
      justify-content: flex-end;

      > li {
        display: flex;
        align-items: center;
        padding: $mainnavi-linkitem-padding;

        > .mainnavi-link {
          padding: $mainnavi-link-padding;
          font-size: $mainnavi-link-font-size;
          color: $mainnavi-link-color;
          text-decoration: $mainnavi-link-textdecoration;

          &:hover {
            color: $mainnavi-link-hover-color;
          }
        }

        &.has-dropdown {
          display: flex;
          align-items: center;
          position: relative;

          &::before {
            display: block;
            content: '';
            flex: 1 0 auto;
            float: left;
            position: relative;
            top: 1px;
            margin-right: 7px;
            width: 12px;
            height: 12px;
            background-image: url('~@/assets/images/icons/dropdown-arrow-primary.svg');
            background-size: contain;
          }

          > ul {
            display: none;
            position: absolute;
            top: 100%;
            right: 0;
            min-width: 100%;
            background-color: $mainnavi-dropdown-bg;

            li {
              > .mainnavi-link {
                padding: $mainnavi-dropdown-link-padding;
                font-size: $mainnavi-dropdown-link-font-size;
                color: $mainnavi-dropdown-link-color;
                text-decoration: $mainnavi-dropdown-link-textdecoration;

                &:hover {
                  background-color: $mainnavi-dropdown-link-hover-bg;
                  color: $mainnavi-dropdown-link-hover-color;
                }
              }

              &.router-link-exact-active {
                > .mainnavi-link {
                  background-color: $mainnavi-dropdown-link-active-bg;
                  color: $mainnavi-dropdown-link-active-color;
                  font-weight: bold;
                }
              }
            }
          }
        }

        &:hover {
          > ul {
            display: block;
          }
        }

        &.router-link-exact-active {
          > .mainnavi-link {
            color: $mainnavi-link-active-color;
            font-weight: bold;
          }
        }
      }
    }

    .main-navigation-link--adminhome {
      border-right: $mainnavi-seperator;
    }

    .md.menu-opened &,
    .sm.menu-opened &,
    .xs.menu-opened & {
      transform: translateX(0%);
    }
  }

  .md &,
  .sm &,
  .xs & {
    .o-main-navigation {
      position: absolute;
      top: $header-mobile-height;
      right: 0;
      padding-bottom: $header-mobile-height;
      width: 100%;
      height: calc(100vh - #{$header-mobile-height});
      background-color: $mainnavi-mobile-bg;
      overflow: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      transform: translateX(100%);
      transition: $mainnavi-mobile-toggle-transition;

      > ul {
        display: block;

        > li {
          margin: $mainnavi-mobile-linkitem-padding;
          padding: 0;

          > .mainnavi-link {
            padding: $mainnavi-mobile-link-padding;
            font-size: $mainnavi-mobile-link-font-size;
            color: $mainnavi-mobile-link-color;

            &:hover {
              color: $mainnavi-mobile-link-hover-color;
            }
          }

          &.has-dropdown {
            display: block;

            &:before {
              display: none;
            }

            > ul {
              display: block;
              position: static;
              background-color: $mainnavi-mobile-dropdown-bg;

              li {
                > .mainnavi-link {
                  padding: $mainnavi-mobile-dropdown-link-padding;
                  font-size: $mainnavi-mobile-dropdown-link-font-size;
                  color: $mainnavi-mobile-dropdown-link-color;

                  &:hover {
                    background-color: $mainnavi-mobile-dropdown-link-hover-bg;
                    color: $mainnavi-mobile-dropdown-link-hover-color;
                  }
                }

                &.router-link-exact-active {
                  > .mainnavi-link {
                    background-color: $mainnavi-mobile-dropdown-link-active-bg;
                    color: $mainnavi-mobile-dropdown-link-active-color;
                  }
                }
              }
            }
          }

          &.router-link-exact-active {
            > .mainnavi-link {
              color: $mainnavi-mobile-link-active-color;
            }
          }
        }
      }

      .main-navigation-link--username {
        > .mainnavi-link {
          display: none;
        }
      }

      .main-navigation-link--adminhome {
        border-bottom: $mainnavi-seperator;
        border-right: 0 none;
      }
    }
  }

  .o-nav-toggler {
    display: none;
    cursor: pointer;

    &__item {
      width: $mainnavi-toggler-item-width;
      height: $mainnavi-toggler-item-height;
      background-color: $mainnavi-toggler-item-bg;
      transition: $mainnavi-toggler-item-transition;

      &:nth-child(1) {
        transform-origin: top right;
      }

      &:nth-child(2) {
        transform-origin: center right;
      }

      &:nth-child(3) {
        transform-origin: bottom right;
      }

      + .o-nav-toggler__item {
        margin-top: $mainnavi-toggler-item-gap;
      }
    }

    .md &,
    .sm &,
    .xs & {
      display: block;
    }

    .md.menu-opened &,
    .sm.menu-opened &,
    .xs.menu-opened & {
      &__item {
        &:nth-child(1) {
          transform: rotate(-45deg);
        }

        &:nth-child(2) {
          opacity: 0;
          transform: scale(0);
        }

        &:nth-child(3) {
          transform: rotate(45deg);
        }
      }
    }
  }

  @media print {
    border-bottom: 2px solid #979797;

    .o-main-navigation {
      display: none;
    }

    .o-nav-toggler {
      display: none;
    }
  }
}
</style>
